<div class="lecture-video">
	<div style="padding:56.25% 0 0 0;position:relative;">
		<iframe [src]="parseVideoIDIntoSrc(lecture?.video_id)" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="{{lecture?.title}}"></iframe>
	</div>
</div>

<div class="overview" [innerHTML]="lecture?.overview"></div>

<div class="btn-group btn-group-wrap resource-buttons" *ngIf="lecture?.recommended_readings && lecture?.recommended_readings.length > 0">
	<a *ngFor="let reading of lecture?.recommended_readings" [href]="reading.url" target="_blank" class="btn btn-primary btn-spaced" [innerHtml]="(reading.description || reading.name) | simpleMd"></a>
</div>
